import React, { useEffect, useState } from "react";
import morrisonsLogo from "assets/images/morrisons-logo.png";
import { Container } from "@mui/system";
import { menuItems, menuSortOrder } from "data/data";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "@mui/material/Avatar";
import Divider from "@mui/material/Divider";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import Logout from "@mui/icons-material/Logout";
import ListItemIcon from "@mui/material/ListItemIcon";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { logout } from "redux/actions/userActions";
import { Link as MuiLink, useMediaQuery } from "@mui/material";
import {
  PAGE,
  STOCK_ORDER_SERVICES,
  TERMINATE_TOKEN,
} from "components/common/CONSTANTS";
import { clearLocations } from "redux/actions/locationActions";
import { SOMS_API_KEY } from "services/CONSTANTS";
import { postTokenSession } from "services/loginService";
import { encryptRequest } from "components/common/EncryptDecrypt";
import jwt_decode from "jwt-decode";
import { BroadcastChannel } from "broadcast-channel";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MenuList } from "./menuList";
const logoutChannel = new BroadcastChannel("logout");

export const Header = () => {
  const [activeContent, setActiveContent] = useState(STOCK_ORDER_SERVICES);
  const [profileMenuEl, setProfileMenuEl] = useState(null);
  const [menuEl, setMenuEl] = useState(null);
  const isSmallScreen = useMediaQuery("(max-width:600px");
  const navigate = useNavigate();
  const openProfile = Boolean(profileMenuEl);
  const openMenu = Boolean(menuEl);
  const location = useLocation();
  const dispatch = useDispatch();
  const [menuOptions, setMenuOptions] = useState([]);

  const loggedInUser = useSelector((state) => state.user);
  const userType = useSelector((state) => {
    return state.user;
  });
  const { accessiblePages } = userType.userType;

  const handleMenuClick = (event) => {
    setMenuEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuEl(null);
  };

  const handleProfileClick = (event) => {
    setProfileMenuEl(event.currentTarget);
  };

  const handleProfileClose = () => {
    setProfileMenuEl(null);
  };

  const handleNavigate = (url, breadcrumbName) => {
    navigate(url);
    setActiveContent(breadcrumbName);
    handleMenuClose();
  };

  const handleLogout = async() => {
    handleProfileClose();
    dispatch(clearLocations());
    const token = sessionStorage.getItem("token");
    const credentials = jwt_decode(token);
    const finalReq = {
      tokenType: TERMINATE_TOKEN,
      accessToken: "",
      expiresIn: "",
      refreshToken: sessionStorage.getItem("refreshToken"),
      scope: "",
      userType: "",
      empId: "",
      primaryEmailAddress: credentials.email,
      roleCode: "",
      roles: "",
    };
    const request1 = await encryptRequest(finalReq);
    const request = {
      apikey: SOMS_API_KEY,
      params: {
        token: request1,
      },
      userId: credentials.email,
    };
    postTokenSession(request)
      .then((res) => {
        logoutChannel.postMessage("Logout");
        dispatch(logout());
        localStorage.clear();
        sessionStorage.clear();
        navigate("/");
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (accessiblePages) {
      const pages = Object.keys(accessiblePages);
      const menuObj = {};
      pages.forEach(function (page) {
        const accessablePage = menuItems[page];
        if (accessablePage) {
          const menuHeader = accessablePage.header;
          if (menuObj[menuHeader]) {
            const itemList = menuObj[menuHeader];
            if (itemList.indexOf(accessablePage) < 0) {
              menuObj[menuHeader] = [...itemList, accessablePage];
            }
          } else {
            menuObj[menuHeader] = [accessablePage];
          }
        }
      });
      const menu = [];
      const menuObjKeys = Object.keys(menuObj);

      menuObjKeys.forEach(function (item) {
        if (menuObj[item]) {
          menu.push({
            listHeader: item,
            sortOrder: menuSortOrder.indexOf(item),
            // listItems: menuObj[item],
            listItems: menuObj[item].sort((a, b) => {
              const sortSubMenuA = a.sortMenu ? parseInt(a.sortMenu, 10) : Infinity;
              const sortSubMenuB = b.sortMenu ? parseInt(b.sortMenu, 10) : Infinity;
              return sortSubMenuA - sortSubMenuB;
            }),
          });

        }
      });

      menu.sort((a, b) => {
        if (a.sortOrder !== -1 && b.sortOrder !== -1) {
          return a.sortOrder - b.sortOrder;
        } else if (a.sortOrder !== -1) {
          return -1;
        } else if (b.sortOrder !== -1) {
          return 1;
        } else {
          return 0;
        }
      });
      setMenuOptions(menu);
    }
  }, [accessiblePages]);

  useEffect(() => {
    const menuItemMasterKeys = Object.keys(PAGE);
    const menuList = menuItemMasterKeys.map((item) => PAGE[item]); // Convert object to array
  
    const matchedMenuItem = menuList.find((x) => x.url === location.pathname);
  
    // Check if the user is on either the error feedback or validate emergency orders page
    const isErrorPage =
      location.pathname === PAGE.ERROR_FEEDBACK?.url ||
      location.pathname === PAGE.VALIDATE_EMERGENCY_ORDERS?.url;
  
    if (isErrorPage) {
      // If it's a special page, set the breadcrumb to the label from the respective page
      setActiveContent(
        location.pathname === PAGE.ERROR_FEEDBACK.url
          ? PAGE.ERROR_FEEDBACK.label
          : location.pathname === PAGE.VALIDATE_EMERGENCY_ORDERS.url
          ? PAGE.VALIDATE_EMERGENCY_ORDERS.label
          : "SOMS"
      );
      return; // Skip setting to "SOMS" if on special pages
    }
  
    setActiveContent(matchedMenuItem ? matchedMenuItem.label : "SOMS"); // Default to "SOMS" if no match
  }, [location.pathname]);

  return (
    <>
      <Box
        component="header"
        className="headerClass"
        bgcolor="primary.main"
        sx={{ py: 2, textAlign: "left" }}
      >
        <Container
        maxWidth="false"
          sx={{ display: "flex", justifyContent: "space-between" }}
        >
          <Box
            component="img"
            sx={{
              cursor: "pointer",
            }}
            alt="Morrisons"
            src={morrisonsLogo}
            onClick={() => {
              setActiveContent(STOCK_ORDER_SERVICES);
              navigate(PAGE.HOME.url);
            }}
          />

          {loggedInUser.loginResponse && (
            <>
              <Tooltip>
                <Button
                  onClick={handleProfileClick}
                  size="small"
                  sx={{ ml: 2, color: "white" }}
                  aria-controls={openProfile ? "profile-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={openProfile ? "true" : undefined}
                  startIcon={
                    <Avatar className="loginAvatar"
                      sx={{ width: 24, height: 24 }}
                      src={loggedInUser.loginResponse.picture}
                      alt={loggedInUser.loginResponse.name}
                    />
                  }
                  endIcon={
                    <KeyboardArrowDownIcon fontSize="small"></KeyboardArrowDownIcon>
                  }
                  disableRipple={true}
                >
                  {loggedInUser.loginResponse.name}
                </Button>
              </Tooltip>
              <Menu
                anchorEl={profileMenuEl}
                id="profile-menu"
                open={openProfile}
                onClose={handleProfileClose}
                onRequestClose={handleProfileClose}
                onClick={handleProfileClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    marginTop: "7px",
                    "& .MuiAvatar-root": {
                      width: 24,
                      height: 24,
                      ml: -0.5,
                      mr: 1,
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem onClick={handleProfileClose}>
                  <Avatar /> View Profile
                </MenuItem>
                <Divider />
                <MenuItem onClick={handleLogout}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  Sign Out
                </MenuItem>
              </Menu>
            </>
          )}
        </Container>
      </Box>
      {loggedInUser.loginResponse && (
        <>
          <Container maxWidth="false" className="hamburgerSection" sx={{ display: "flex", flexDirection: "row" }}>
            <Toolbar disableGutters variant="dense">
              <IconButton
                size="small"
                edge="start"
                color="inherit"
                aria-label="menu"
                id="menu-button"
                sx={{ mr: 2 }}
                aria-controls={openMenu ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openMenu ? "true" : undefined}
                onClick={handleMenuClick}
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={menuEl}
                open={openMenu}
                onClose={handleMenuClose}
                className="menuHamburger"
                MenuListProps={{
                  "aria-labelledby": "menu-button",
                }}
                sx={{
                  "& .MuiMenu-list": { backgroundColor: "primary.main" },
                  maxHeight: isSmallScreen ? "80vh" : "auto",
                  overflow: "auto",
                }}
              >
                {menuOptions.length === 1 &&
                menuOptions[0].listItems.length === 1 ? (
                  <MenuList
                    itemList={menuOptions[0].listItems}
                    onItemSelected={(url, breadcrumbName) =>
                      handleNavigate(url, breadcrumbName)
                    }
                  />
                ) : (
                  menuOptions.map((item) => (
                    <Accordion key={item.listHeader} sx={{ boxShadow: "none" }}>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        className="menuHeader"
                        sx={{
                          color: "primary.contrastText",
                          backgroundColor: "primary.main",
                          pl: 4,
                        }}
                      >
                        {item.listHeader}
                      </AccordionSummary>
                      <MenuList
                        itemList={item.listItems}
                        onItemSelected={(url, breadcrumbName) =>
                          handleNavigate(url, breadcrumbName)
                        }
                      />
                    </Accordion>
                  ))
                )}
              </Menu>
            </Toolbar>
            <Breadcrumbs
              aria-label="breadcrumb" className="breadCrumbStyle"
              sx={{ display: "flex", fontSize: "0.98rem" }}
            >
              <MuiLink
                component={Link}
                underline="hover"
                color="inherit"
                to="/home"
                onClick={() => setActiveContent(STOCK_ORDER_SERVICES)}
              >
                Home
              </MuiLink>
              <Typography variant="body1" color="text.primary">
                {activeContent}
              </Typography>
            </Breadcrumbs>
          </Container>
          <Divider />
        </>
      )}
    </>
  );
};
